import reducer from "./reducer";
export { default as LocationSettings } from "./components/index";
export { default as locationSettingsReducerName } from "./constants";
export default reducer;
